import React, { useState, useContext } from "react";
import { MdDelete } from "react-icons/md";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { showSuccess, showError } from "../../utils/toast";
import ButtonUI from "../material-ui/ButtonUI";
import deleteEmailTemplateTableRecord from "../../api/deleteEmailTemplateTableRecord";
import { AuthContext } from "../../context/Auth/AuthContext";

const BulkDeleteEmailTemplatePopup = ({
  bulkIds,
  bulkDeleteEmailTemplate,
  setBulkDeleteEmailTemplate,
  setRowSelection,
  setEmailTemplatesAddedToTrue,
}) => {
  const { token } = useContext(AuthContext);

  const handleClose = () => {
    setBulkDeleteEmailTemplate(false);
  };

  const onBulkDeleteSubmit = async () => {
    const response = await deleteEmailTemplateTableRecord({
      token: token,
      id: bulkIds,
    });

    if (response?.code === 200) {
      setBulkDeleteEmailTemplate(false);
      setRowSelection({});
      setEmailTemplatesAddedToTrue();
      showSuccess("Email Templates deleted successfully");
    } else {
      showError("Error while deleting Email Templates");
    }
  };

  return (
    <Dialog
      open={bulkDeleteEmailTemplate}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" className="edit-doc-modal">
        <div className="popup-header-svg-icon">
          <MdDelete />
        </div>
        <div className="popup-header-title">Delete Email Templates</div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Are you sure you want to delete all selected Email Templates?
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ justifyContent: "flex-end" }}>
        <ButtonUI
          formButton={false}
          variant="outlined"
          buttonText="No"
          style={{
            margin: "15px 0px",
            backgroundColor: "#fff",
            color: "#1a6b7c",
            border: "1px solid #1a6b7c",
          }}
          onClickFunc={handleClose}
        />
        <ButtonUI
          formButton={false}
          variant="outlined"
          buttonText="Yes"
          style={{
            margin: "15px",
            backgroundColor: "#fff",
            color: "#1a6b7c",
            border: "1px solid #1a6b7c",
          }}
          autoFocus={true}
          onClickFunc={() => {
            onBulkDeleteSubmit();
          }}
        />
      </DialogActions>
    </Dialog>
  );
};

export default BulkDeleteEmailTemplatePopup;
